import { api } from './api';

// Get user's download history
export const getUserDownloads = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    if (filters.startDate) {
      params.append('startDate', filters.startDate.toISOString());
    }
    if (filters.endDate) {
      params.append('endDate', filters.endDate.toISOString());
    }
    if (filters.status && filters.status !== 'all') {
      params.append('status', filters.status);
    }
    if (filters.productVersion && filters.productVersion !== 'all') {
      params.append('versionId', filters.productVersion);
    }
    
    const response = await api.get(`/downloads/stats?userId=${userId}&${params.toString()}`);
    return response.data.downloads;
  } catch (error) {
    console.error('Error fetching user downloads:', error);
    throw error;
  }
};

const downloadService = {
  getUserDownloads
};

export { downloadService };